import * as React from "react";
const View = require("../../views/Landing/ModalLandingPageRessources.view");
import {
  checkEmail,
  checkNameAdminDemandeContact,
  checkNameEtablissement,
  checkMultiple
} from "../../utils/CheckUtils";
import { isNullOrUndefined } from "util";
import * as Utils from "../../utils/Utils";
import * as AnalyticsUtils from "../../utils/AnalyticsUtils";

interface IPropsModalLandingPageRessources {
  show: boolean;
  onHide: () => void;
}
interface IStateModalLandingPageRessources {
  etablissementName: string;
  name: string;
  fonction: string;
  email: string;
  errorMessage: string;
  isLoading: boolean;
}
class ModalLandingPageRessources extends React.Component {
  state: IStateModalLandingPageRessources;
  props: IPropsModalLandingPageRessources;
  constructor(props) {
    super(props);
    this.state = {
      etablissementName: "",
      name: "",
      fonction: "",
      email: "",
      errorMessage: "",
      isLoading: false
    };
  }

  onChange(key: string, value: string): void {
    this.setState({
      [key]: value
    });
  }

  render() {
    return (
      <View
        etablissementName={this.state.etablissementName}
        name={this.state.name}
        fonction={this.state.fonction}
        email={this.state.email}
        show={this.props.show}
        onHide={this.onHide.bind(this)}
        onChange={this.onChange.bind(this)}
        nextPage={this.nextPage.bind(this)}
        errorMessage={this.state.errorMessage}
        isLoading={this.state.isLoading}
      />
    );
  }

  nextPage() {
    let email = this.state.email.trim();
    let name = this.state.name;
    let etablissementName = this.state.etablissementName;
    let fonction = this.state.fonction;

    let checks = [];
    checks.push(checkNameAdminDemandeContact(name));
    checks.push(checkNameEtablissement(etablissementName));
    checks.push(checkEmail(email));

    let { errorMessage } = checkMultiple(checks);

    if (!isNullOrUndefined(errorMessage)) {
      this.setState({
        errorMessage: errorMessage,
        infoMessage: ""
      });
      return;
    }

    this.update({
      email: email,
      fonction: fonction,
      etablissementName: etablissementName,
      name: name
    });
  }

  onHide() {
    this.props.onHide();
  }

  async update(_data) {
    this.setState({ isLoading: true });
    try {
      AnalyticsUtils.analytics().track("White Book downloaded");

      let postData = {
        name: _data.name,
        email: _data.email,
        institution: _data.etablissementName,
        job: _data.fonction
      };
      let data = await Utils.request("/downloadWhiteBook", "POST", postData);
      this.setState({ isLoading: false });
      this.onHide();
    } catch (err) {
      console.error(err);
      if (err.responseText) {
        this.setState({
          errorMessage: err.responseText,
          isLoading: false
        });
      } else {
        this.setState({
          errorMessage: err,
          isLoading: false
        });
      }
    }
  }
}

export default ModalLandingPageRessources;



// WEBPACK FOOTER //
// ./assets/react/components/Landing/ModalLandingPageRessources.component.tsx